export default "__VITE_ASSET__C76$7QZX__"